import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Input from "@builder/components/general/Input";
import SelectInput from "@builder/components/general/SelectInput";
import Toggle from "@builder/components/general/Toggle";
import useFilterOptions from "@builder/hooks/useFilterEditor";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { RadioFieldNode } from "@common/build/types";
import { useState } from "react";

const EditRadioField = ({ parent }: EditableProps) => {
  const dispatch = useAppDispatch();
  const node = useAppSelector(getSelectedNode) as RadioFieldNode;
  const [showLabel, setShowLabel] = useState(!!node.input?.label);


  const { options: radioOptions, value: radioValue, callback: radioCallback, target } = useFilterOptions({ node });

 
  if (!target) return null;

  const label = node.input?.label || "";
  const labelCallback = (value: string) => {
    dispatch(updateNodeProperty({ propertyPath: ["input", "label"], value }));
  };

  const wrap = node.wrap || false;
  const wrapCallback = (checked: boolean) => {
    dispatch(updateNodeProperty({ propertyPath: ["wrap"], value: checked }));
  };

  return (
    <SidebarCollapse title="Radio buttons" parent={parent}>
      <SelectInput title="Radio data" layout="column" value={radioValue} options={radioOptions} callback={radioCallback} />
      <Toggle
        label="Show label?"
        checked={showLabel}
        callback={() => {
          labelCallback(showLabel ? "" : "Label");
          setShowLabel(!showLabel);
        }}
      />
      {showLabel && <Input label="Label" placeholder="Enter label" value={label} callback={labelCallback} />}
      <Toggle label="Wrap buttons" checked={wrap} callback={wrapCallback} />
    </SidebarCollapse>
  );
};

export default EditRadioField;
